import { MapPin } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const AREAS = ["Bromsgrove", "Birmingham", "Dudley", "Redditch", "Worcestershire", "Gloucestershire", "Cheltenham"];

export default function AreasStrip() {
  return (
    <section data-testid="areas-strip" className="bg-[#0d0d0d] border-b border-white/10 py-6 md:py-7">
      <Reveal>
        <div className="max-w-[1200px] mx-auto px-6 md:px-12 flex flex-wrap items-center justify-center gap-x-2 gap-y-2 text-center">
          <span className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-semibold text-[#c5832b] mr-2">
            <MapPin size={14} /> Areas we cover
          </span>
          {AREAS.map((a, i) => (
            <span key={a} className="text-sm md:text-base text-[#f5f5f0]/85">
              {a}
              {i < AREAS.length - 1 && <span className="text-[#c5832b] ml-2">·</span>}
            </span>
          ))}
        </div>
      </Reveal>
    </section>
  );
}
